export const layers = {
  relief: {
    accent_5: {
      shadow: `
        box-shadow:
          0px 0px 0px 0.5px rgba(255, 255, 255, 1) inset,
          0px -17px 10px -1px rgba(252, 251, 248, 1) inset,
          0px 0px 12px -6px rgba(199, 196, 183, 1);
        opacity: 1;
        background-color: rgba(253, 253, 251, 1);
      `,
    },
    accent_10: {
      shadowHigher: `
        box-shadow:
          0px 0px 4px 2px rgba(253, 253, 251, 1) inset,
          0px 0px 0px 0.5px rgba(255, 255, 255, 1) inset,
          0px -17px 10px -1px rgba(250, 249, 244, 1) inset,
          0px 1px 4px rgba(9, 9, 11, 0.08),
          0px 0px 12px -6px rgba(173, 169, 153, 1);
        opacity: 1;
        background-color: rgba(252, 251, 248, 1);
      `,
    },
    accent_20: {
      noShadow: `
        box-shadow:
          0px 0px 0px 0.5px rgba(252,251,248, 1),
          0px -17px 10px -1px rgba(244,243,237, 1);
        opacity: 1;
        background-color: rgba(250,249,244, 1);
      `,
      shadow: `
        box-shadow: 0px 1px 4px rgba(9,9,11, 0.08),
          0px 0px 12px -6px rgba(199,196,183, 1),
          0px 0px 0px 0.5px rgba(252,251,248, 1),
          0px -17px 10px -1px rgba(244,243,237, 1);
        opacity: 1;
        background-color: rgba(250,249,244, 1);
      `,
    },
    accent_30: {
      noShadow: `
        box-shadow:
          0px 0px 12px -6px rgba(199, 196, 183, 1),
          0px 0px 4px 2px rgba(211, 209, 199, 1),
          0px 0px 0px 0.5px rgba(250, 249, 244, 1),
          0px -6px 12px -2px rgba(255, 255, 255, 1);
        opacity: 1;
        background-color: rgba(237, 236, 229, 1);
      `,
      shadow: `
        box-shadow:
          0px 0px 4px rgba(9, 9, 11, 0),
          0px 0px 12px -6px rgba(199, 196, 183, 1),
          0px 0px 4px 2px rgba(211, 209, 199, 1),
          0px 0px 0px 0.5px rgba(250, 249, 244, 1),
          0px -6px 12px -2px rgba(255, 255, 255, 1);
        opacity: 1;
        background-color: rgba(237, 236, 229, 1);
      `,
    },
    accent_50: {
      noShadow: `
        box-shadow:
          0px 0px 4px 2px rgba(186, 183, 168, 1) inset,
          0px 0px 0px 0.5px rgba(237, 236, 229, 1) inset,
          0px -6px 12px -2px rgba(255, 255, 255, 1) inset,
          0px 0px 4px rgba(9, 9, 11, 0);
        opacity: 1;
        background-color: rgba(211, 209, 199, 1);
      `,
    },
    accent_70: {
      shadow: `
        box-shadow: 0px 1px 4px rgba(9,9,11, 0.08),
          0px 0px 12px -6px rgba(160,156,138, 1),
          0px 0px 0px 0.5px rgba(199,196,183, 1),
          0px -17px 10px -1px rgba(186,183,168, 1);
        opacity: 1;
        background-color: rgba(199,196,183, 1);`,
      noShadow: `
        box-shadow: 0px 0px 0px 0.5px rgba(199,196,183, 1),
          0px -17px 10px -1px rgba(186,183,168, 1);
        opacity: 1;
        background-color: rgba(199,196,183, 1);
      `,
    },
    accentDark_10: {
      noShadow: `
        box-shadow:
          0px 0px 2px 1px rgba(78, 75, 66, 1),
          0px 0px 0px 0.25px rgba(186, 183, 168, 1);
        opacity: 1;
        background-color: rgba(94, 91, 80, 1);
      `,
    },
    primaryDark_10: {
      noShadow: `
        box-shadow:
          0px 0px 4px 2px rgba(65, 76, 131, 1) inset,
          0px 0px 0px 0.5px rgba(90, 100, 148, 1) inset,
          0px -17px 10px -1px rgba(32, 42, 91, 1) inset;
        opacity: 1;
        background-color: rgba(40, 52, 114, 1);
      `,
      shadow: `
        box-shadow:
          0px 0px 4px 2px rgba(65, 76, 131, 1) inset,
          0px 0px 0px 0.5px rgba(90, 100, 148, 1) inset,
          0px -17px 10px -1px rgba(32, 42, 91, 1) inset,
          0px 1px 6px rgba(9, 9, 11, 0.08),
          0px 0px 6px rgba(140, 147, 182, 1);
        opacity: 1;
        background-color: rgba(40, 52, 114, 1);
      `,
    },
    primaryMidDark_20: {
      shadowHigher: `
        box-shadow:
          0px 0px 4px 2px rgba(78, 88, 140, 1) inset,
          0px 0px 0px 0.5px rgba(115, 123, 165, 1) inset,
          0px -17px 10px -1px rgba(40, 52, 114, 1) inset,
          0px 2px 6px rgba(9, 9, 11, 0.08),
          0px 0px 6px 1px rgba(140, 147, 182, 1);
        opacity: 1;
        background-color: rgba(53, 64, 123, 1);
      `,
    },
    uiGrey_5: {
      shadow: `
        box-shadow:
          0px 0px 4px 2px rgba(255, 255, 255, 1) inset,
          0px 0px 0px 0.5px rgba(255, 255, 255, 1) inset,
          0px -17px 10px -1px rgba(244, 244, 246, 1) inset,
          0px 0px 12px -6px rgba(147, 150, 169, 1);
        opacity: 1;
        background-color: rgba(250, 250, 251, 1);
      `,
      noShadow: `
        border: 1px solid rgba(234, 234, 238, 1);
        box-shadow:
          0px 0px 4px 2px rgba(255, 255, 255, 1),
          0px 0px 0px 0.5px rgba(255, 255, 255, 1),
          0px -17px 10px -1px rgba(244, 244, 246, 1);
        opacity: 1;
        background-color: rgba(250, 250, 251, 1);
      `,
    },
    uiGrey_10: {
      shadow: `box-shadow: 0px 0px 2px 1px rgba(255,255,255, 1) inset,
          0px 0px 0px 0.25px rgba(234,234,238, 1) inset,
          0px 2px 4px rgba(9,9,11, 0.08),
          0px 0px 4px rgba(224,224,230, 1);
        opacity: 1;
        background-color: rgba(244,244,246, 1);`,
      shadowHigher: `
        box-shadow:
          0px 0px 4px 2px rgba(250, 250, 251, 1) inset,
          0px 0px 0px 0.5px rgba(255, 255, 255, 1) inset,
          0px -17px 10px -1px rgba(234, 234, 238, 1) inset,
          0px 1px 4px rgba(9, 9, 11, 0.08),
          0px 0px 12px -6px rgba(147, 150, 169, 1);
        opacity: 1;
        background-color: rgba(244, 244, 246, 1);
      `,
    },
    uiGrey_30: {
      shadow: `
        box-shadow:
          0px 0px 4px 2px rgba(164, 166, 182, 1) inset,
          0px 0px 0px 0.5px rgba(234, 234, 238, 1) inset,
          0px -6px 12px -2px rgba(255, 255, 255, 1) inset,
          0px 0px 4px rgba(9, 9, 11, 0),
          0px 0px 12px -6px rgba(164, 166, 182, 1);
        opacity: 1;
        background-color: rgba(198, 200, 210, 1);
      `,
    },
    uiGrey_40: {
      shadow: `
        box-shadow:
          0px 1px 4px rgba(9, 9, 11, 0.08),
          0px 0px 12px -6px rgba(131, 134, 155, 1),
          0px 0px 4px 2px rgba(224, 224, 230, 1),
          0px 0px 0px 0.5px rgba(234, 234, 238, 1),
          0px -17px 10px -1px rgba(181, 184, 196, 1);
        opacity: 1;
        background-color: rgba(198, 200, 210, 1);
      `,
      noShadow: `
        box-shadow:
          0px 0px 4px 2px rgba(224, 224, 230, 1),
          0px 0px 0px 0.5px rgba(234, 234, 238, 1),
          0px -17px 10px -1px rgba(181, 184, 196, 1);
        opacity: 1;
        background-color: rgba(198, 200, 210, 1);
      `,
    },
  },
  inset: {
    primaryDark_10: {
      shadow: `
        box-shadow:
          0px 0px 4px rgba(9, 9, 11, 0),
          0px 0px 6px rgba(140, 147, 182, 1),
          0px 0px 4px 2px rgba(20, 26, 57, 1),
          0px 0px 0px 0.5px rgba(32, 42, 91, 1),
          0px -6px 12px -2px rgba(40, 52, 114, 1);
        opacity: 1;
        background-color: rgba(28, 37, 80, 1);
      `,
      noShadow: `
        box-shadow:
          0px 0px 4px rgba(9, 9, 11, 0),
          0px 0px 4px 2px rgba(20, 26, 57, 1),
          0px 0px 0px 0.5px rgba(32, 42, 91, 1),
          0px -6px 12px -2px rgba(40, 52, 114, 1);
        opacity: 1;
        background-color: rgba(28, 37, 80, 1);
      `,
    },
  },
  bubble: {
    uiGrey_10: {
      shadow: `
        box-shadow:
          0px 0px 2px 1px rgba(255, 255, 255, 1) inset,
          0px 0px 0px 0.25px rgba(234, 234, 238, 1) inset,
          0px 2px 4px rgba(9, 9, 11, 0.08),
          0px 0px 4px rgba(224, 224, 230, 1);
        opacity: 1;
        background-color: rgba(244, 244, 246, 1);
      `,
    },
  },
};
